import { render } from "./App.vue?vue&type=template&id=449b3c85&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=449b3c85&lang=css"
import "./App.vue?vue&type=style&index=1&id=449b3c85&lang=less&scoped=true"

import exportComponent from "/Users/sun/Documents/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449b3c85"]])

export default __exports__